import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Provider } from '../../../api-clients/oem-connection';
import { PROVIDER_LABELS } from '../integrations.component';

/**
 * Farms & fields linkage page (SRA003-449). Hosts the farm-link and
 * field-link panels on their own route (`/integrations/farms/:provider`),
 * separate from the machinery linkage that stays on the per-provider manage
 * view. Pure layout/navigation — all linkage logic lives in the reused
 * panels (SRA003-440 behaviour unchanged).
 */
@Component({
  selector: 'app-farm-field-link-page',
  templateUrl: './farm-field-link-page.component.html',
  styleUrls: ['./farm-field-link-page.component.css'],
  standalone: false,
})
export class FarmFieldLinkPageComponent implements OnInit {
  provider: Provider | null = null;
  providerLabel = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const raw = this.route.snapshot.paramMap.get('provider');
    if (raw === Provider.Deere || raw === Provider.Cnh) {
      this.provider = raw;
      this.providerLabel = PROVIDER_LABELS[raw];
    } else {
      // Unknown provider in the URL — land back on the integrations overview.
      this.router.navigate(['/integrations']);
    }
  }
}
